module.exports = __webpack_public_path__ + "static/sahil-lavingia-733372d5d7755aee53ce2e014069b5c7.jpg";